import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingWeightKg: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.19 16.76v-6.09h-1.52V7.62h-9.15V6.09h1.53V3.05h-1.53V1.52h-6.09v1.53H9.91v3.04h1.52v1.53h-6.1v1.52H22.1v6.1h1.52v4.57h1.52v9.14H2.29v1.53h24.38v-1.53h1.52v-1.52h1.52V25.9h1.53v-4.57h-1.53v-4.57ZM16 6.09h-3.05V3.05H16Z\"/><path fill=\"currentColor\" d=\"M17.52 19.81h1.53v1.52h1.52v-3.05h-3.05zM16 15.24h3.05v1.52H16Zm0 6.09h3.05v1.53H16Zm-1.52-4.57H16v4.57h-1.52Zm-3.05 4.57h1.52v1.53h-1.52Zm0-6.09h1.52v1.52h-1.52Zm-1.52 4.57h1.52v1.52H9.91Zm0-3.05h1.52v1.52H9.91Zm-1.53-1.52H6.86v7.62h1.52v-3.05h1.53v-1.53H8.38zm-4.57-6.1h1.52v6.1H3.81Zm-1.52 6.1h1.52v4.57H2.29ZM.76 19.81h1.53v9.14H.76Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingWeightKg
